import {Navigate} from 'react-router-dom';
import { LOGIN, PRIVATE_USER } from 'Shared/Routing/Application/Constants/PathsConstant';
import {useAuthContext} from 'Shared/Security/Domain/Contexts/authContext';

export default function PrivateRedirector() {
  const {isAuthenticated} = useAuthContext();
  if (!isAuthenticated) {
    return <Navigate to={LOGIN} />;
  }else{
    let targetPath = new URLSearchParams(window.location.search).get('targetPath');
    if (targetPath) {
      return <Navigate to={targetPath} />;
    }
    return <Navigate to={PRIVATE_USER} />;
  }
}
